import { UtmSource } from '../../../../../../services/exports/Constants';
import { CustomUtmSource } from '../../../../../../views/marketing/tracking-links';

export default {
  title: 'Links de rastreio',
  utm_sources: {
    [UtmSource.GoogleBusinessProfile]: 'Google business',
    [UtmSource.SocialMedia]: 'Redes sociais',
  },
  form: {
    utm_source: {
      label: 'Fonte',
      placeholder: 'Selecionar fonte',
      options: {
        [UtmSource.GoogleBusinessProfile]: 'Google business',
        [UtmSource.SocialMedia]: 'Outras redes sociais',
        [CustomUtmSource.Other]: 'Outro',
      },
    },
    utm_source_details: {
      label: 'Fonte personalizada',
      placeholder: 'Introduzir fonte',
    },
    target_product: {
      label: 'Destino',
      placeholder: 'Selecionar destino',
    },
    target_url: {
      label: 'URL de destino',
      placeholder: 'https://google.com',
    },
    utm_medium: {
      label: 'Meio',
      placeholder: 'Introduzir meio',
    },
    utm_campaign: {
      label: 'Campanha',
      placeholder: 'Introduzir campanha',
    },
  },
  fields: {
    utm_source: 'Fonte',
    target_product: 'Destino',
    type: 'Tipo',
    utm_medium: 'Meio',
    utm_campaign: 'Campanha',
    utm_referrer_id: 'ID de referência',
  },
  buttons: {
    create_auto_links: 'Criar links automáticos',
    create_link: 'Criar link',
    create: 'Criar',
    update: 'Atualizar',
    copy_link: 'Copiar link',
    download_qr_code: 'Descarregar código QR',
    edit: 'Editar',
  },
  modals: {
    auto_links_creation: {
      title: 'Tem a certeza?',
      description:
        'Certifique-se de que terminou a configuração da loja (subdomínio da loja online / domínio da montra). Alterá-los após a criação dos links não afetará automaticamente os links existentes!',
    },
  },
  toasts: {
    failed_to_load_data: 'Falha ao carregar dados',
    failed_to_save_changes: 'Falha ao guardar alterações',
    changes_got_saved: 'Alterações guardadas',
    link_got_copied: 'Link copiado!',
    failed_to_download_qr_code: 'Falha ao descarregar código QR',
  },
};
